import React from 'react';
import styled from 'styled-components';

import Badge from 'components/lib/ui/Badge';
import type { BadgeColors } from 'components/lib/ui/Badge';
import FlexContainer from 'components/lib/ui/FlexContainer';

import type { BlockRenderer, BadgeBlock } from 'common/lib/posts/types';
import { spacing } from 'common/lib/theme/dynamic';

const Root = styled(FlexContainer)`
  margin-top: ${spacing.small};
  margin-bottom: ${spacing.small};
`;

const StyledBadge = styled(Badge)`
  margin: 0;
`;

const BadgeBlockRenderer: BlockRenderer<BadgeBlock> = ({ data: { text, color } }) => (
  <Root>
    <StyledBadge color={color as BadgeColors}>{text}</StyledBadge>
  </Root>
);

export default BadgeBlockRenderer;
